export default "__VITE_ASSET__AdPvaKy5__"